import { ImportTypeInsuranceCarrier } from '@/api/admin/insurance-carrier';
import { Button } from '@/components/ui/button';
import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';

import { UpdateImportTypeInsuranceCarrier } from './sheet-update';

export const getColumns = (
	importTypeId: number,
): ColumnDef<ImportTypeInsuranceCarrier>[] => [
	{
		accessorKey: 'importTypeLobId',
		header: ({ column }) => (
			<div className="text-right">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Company Location Ref Id
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="text-right font-medium">{row.original.importTypeLobId}</div>
			);
		},
	},
	{
		accessorKey: 'companyName',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Location
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.companyName}
				</div>
			);
		},
	},
	{
		accessorKey: 'naicCode',
		header: ({ column }) => (
			<div className="text-right">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					NAIC Code
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return <div className="text-right font-medium">{row.original.naicCode}</div>;
		},
	},
	{
		accessorKey: 'naicId',
		header: ({ column }) => (
			<div className="text-right">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					NAIC Id
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return <div className="text-right font-medium">{row.original.naicId}</div>;
		},
	},
	{
		id: 'actions',
		cell: ({ row }) => (
			<div>
				{
					<UpdateImportTypeInsuranceCarrier
						importTypeInsuranceCarrier={row.original}
						importTypeId={importTypeId}
					/>
				}
			</div>
		),
	},
];
